import axios, { AxiosPromise } from 'axios';
import { IGetPublisher, IGetPublishers, IGetPublishersParams, IGetSchools, IGetSchoolsParams, IPostPublisherReq, IPutPublisherReq } from '../models/publishers.model';

const url = '/mgmt/publishers';

export const getPublishers = (params: IGetPublishersParams): AxiosPromise<IGetPublishers> => {
  return axios.get(url, { params });
};

export const getPublisher = (schoolCode: string): AxiosPromise<IGetPublisher> => {
  return axios.get(`${url}/${schoolCode}`);
};

export const postPublisher = (req: IPostPublisherReq): AxiosPromise => {
  return axios.post(url, req);
};

export const putPublisher = (schoolCode: string, req: IPutPublisherReq[]): AxiosPromise => {
  return axios.put(`${url}/${schoolCode}`, req);
};

export const deletePublisher = (schoolCode: string): AxiosPromise => {
  return axios.delete(`${url}/${schoolCode}`);
};

export const getSchools = (params: IGetSchoolsParams): AxiosPromise<IGetSchools> => {
  return axios.get(`${url}/schools`, { params });
};